import { Renderer } from '@unseenco/taxi';
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { isDEVMODE, viewStorage } from '../_globals'
import WknSwiper from '../modules/wkn-swiper';


export default class NousRejoindre extends Renderer {

  initialLoad() {
    this.onEnter()
  }

  onEnter() {
    this.DOM = {
      swiperValues : viewStorage.current.querySelector('.Values__swiper'),
      swiperGridSlider : viewStorage.current.querySelector('.GridSlider__swiper'),
      swiperProducts : viewStorage.current.querySelector('.block-products__slider .swiper'),
      apply: viewStorage.current.querySelector('.Apply'),
      applyVisuals: [...viewStorage.current.querySelectorAll('.Apply .visual__container')]
    }

    this.init()
  }

  init() {
    this.initSwiperValues()
    this.initSwiperGridSlider()
    this.initSwiperProducts()
    this.initApply()
  }

  initSwiperValues() {
    if (!this.DOM.swiperValues) return

    this.swiperValues = new WknSwiper(this.DOM.swiperValues, {
      slidesPerView: 'auto',
      spaceBetween: 15,
    })
  }

  initSwiperGridSlider() {

    if (!this.DOM.swiperGridSlider) return

    this.swiperGridSlider = new WknSwiper(this.DOM.swiperGridSlider, { 
      slidesPerView: 'auto',
      spaceBetween: 20,
    })
  }

  initSwiperProducts() {
    if (!this.DOM.swiperProducts) return

    this.swiperProducts = new WknSwiper(this.DOM.swiperProducts, { 
      slidesPerView: 'auto',
      spaceBetween: 20,
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
        992: {
          slidesPerView: 4,
        }
      }
    })
  }

  initApply() {
    if (!this.DOM.apply || !this.DOM.applyVisuals.length) return

    this.applyTL = gsap.timeline({
      paused: true,
      defaults: { ease: 'expo.out', duration: 1.6 },
      scrollTrigger : {
        trigger: this.DOM.apply,
        onEnter: () => this.applyTL.invalidate().restart(),
        onEnterBack: () => this.applyTL.invalidate().restart(),
      }
    })

    this.applyTL.fromTo(this.DOM.applyVisuals, { 
      y : () => gsap.utils.random([-this.DOM.apply.offsetHeight, this.DOM.apply.offsetHeight]), 
      rotate: (index) => gsap.utils.random(-20, 20) 
    }, { 
      y : () => gsap.utils.random(this.DOM.apply.offsetHeight * 0.5, 1), 
      rotate: (index) => gsap.utils.random(-20, 20), 
      stagger: 0.05 
    }, 0)
  }

  onLeaveCompleted() {
    this.swiperGridSlider?.destroy()
    this.swiperProducts?.destroy()
    this.applyTL?.kill()
  }
}
